module.exports = __webpack_public_path__ + "img/id.f5aa8121.svg";